import React, { useEffect, useState } from 'react';
import {
  TabContainer,
  TabTitle,
  AddButton,
  AddText,
  ContentContainer,
  Content,
  ContractContainer,
  ContractInfo,
  Date,
  ContractName,
  UploadedBy,
  Buttons,
  UploadContainer,
  ImagesContainer,
  AddPhotoContainer,
  ImagePreview,
  InputImage,
  PdfContainer,
  ContractImagesContainer,
  ImagePreviewBig,
  PdfContainerDetails,
  IconContainer,
  ContractInfoMediaContainer,
  StyledInput,
  ImgUpload,
  PdfUpload,
  RemoveIcon,
  Remove,
  LoadingContainer,
  IconsContainer,
} from './ClientDetails.styles';
import {
  SmallModalContainer,
  Background,
  ModalTitleSmall,
  ButtonContainerGap,
  StyledButton,
  ButtonText,
} from '../../../components/Modal/ModalComponent.styles.js';

import { ReactComponent as Add } from '../../../assets/icons/btnAdd.svg';
import { useDispatch, useSelector } from 'react-redux';
import { selectClientData } from '../../../store/slice/vendor/slice';
import { Waveform } from '@uiball/loaders';
import { ReactComponent as Upload } from '../../../assets/icons/upload.svg';
import { ReactComponent as Download } from '../../../assets/icons/download.svg';
import ModalComponent from '../../../components/Modal/ModalComponent';
import { dateFormatter } from '../../../utils/utils';
import { DOCUMENT_CREATOR, DOCUMENT_MEDIA_TYPE } from '../../../utils/constants';
import {
  resetSelectedContract,
  selectClientContracts,
  selectDeleteDocumentPending,
  selectEditDocumentPending,
  selectFetchClientContractsPending,
  selectGetDocumentByIdPending,
  selectPostClientContractPending,
  selectSelectedContract,
} from '../../../store/slice/wedding/slice';
import {
  deleteDocument,
  editDocument,
  getClientContracts,
  getDocumentById,
  postClientContract,
} from '../../../store/slice/wedding/asyncThunks';
import { notifyError, notifyErrorLeft } from '../../../utils/notify';

import PdfViewer from '../../../components/utils/PdfViewer/PdfViewer';
import { LoaderContainerMargin } from '../ClientsPage.styles';
import { ReactComponent as Delete } from '../../../assets/icons/delete.svg';
import { ReactComponent as Edit } from '../../../assets/icons/edit.svg';
import { toast } from 'react-toastify';

const Contracts = ({ id }) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [contractModalIsOpen, setContractModalIsOpen] = useState(false);
  const contracts = useSelector(selectClientContracts);
  const { firstName, lastName } = useSelector(selectClientData);
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedFile, setSelectedFile] = useState([]);
  const [name, setName] = useState('');
  const [selectedImagesPrev, setSelectedImagesPrev] = useState([]);
  const [selectedPdfPrev, setSelectedPdfPrev] = useState([]);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [edit, setEdit] = useState(true);
  const [pdfToDownloadId, setPdfToDownloadId] = useState(null);

  const [selectedContractToDeleteId, setSelectedContractToDeleteId] = useState(null);

  const postClientContractPending = useSelector(selectPostClientContractPending);
  const fetchClientContractsPending = useSelector(selectFetchClientContractsPending);
  const getDocumentByIdPending = useSelector(selectGetDocumentByIdPending);
  const deleteDocumentPending = useSelector(selectDeleteDocumentPending);
  const editLoading = useSelector(selectEditDocumentPending);

  const selectedContract = useSelector(selectSelectedContract);
  const [newTitle, setNewTitle] = useState('');

  const [documentId, setDocumentId] = useState('');
  const [areYouSureModal, setAreYouSureModal] = useState(false);
  const [isVisible, setIsVisible] = useState(areYouSureModal);

  useEffect(() => {
    let timer;
    if (areYouSureModal) {
      setIsVisible(true);
    } else {
      timer = setTimeout(() => setIsVisible(false), 250);
    }

    return () => clearTimeout(timer);
  }, [areYouSureModal]);

  useEffect(() => {
    dispatch(getClientContracts({ id: id, page: 1 }));
  }, [dispatch, id]);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setName('');
    setSelectedFile([]);
    setSelectedImages([]);
    setSelectedImagesPrev([]);
    setIsModalOpen(false);
  };

  const closeModalDetails = () => {
    dispatch(resetSelectedContract());
    setContractModalIsOpen(false);
    setNewTitle('');
  };

  const handlePhotoInputChange = e => {
    const selectedFiles = e.target.files;
    const selectedImagesArray = [];
    const imagesArray = [];

    for (let i = 0; i < selectedFiles.length; i++) {
      const imageFile = selectedFiles[i];
      selectedImagesArray.push(URL.createObjectURL(imageFile));
      imagesArray.push(imageFile);
    }
    setSelectedImagesPrev(prevSelectedImages => [...prevSelectedImages, ...selectedImagesArray]);
    setSelectedImages(prev => [...prev, ...imagesArray]);
  };

  const handleFileInputChange = e => {
    const selected = e.target.files;

    const selectedImagesArray = [];
    const pdfArray = [];

    for (let i = 0; i < selected.length; i++) {
      const pdfFile = selected[i];
      selectedImagesArray.push(URL.createObjectURL(pdfFile));
      pdfArray.push(pdfFile);
    }
    setSelectedPdfPrev(prevSelectedFiles => [...prevSelectedFiles, ...selectedImagesArray]);
    setSelectedFile(prev => [...prev, ...pdfArray]);
  };

  const handleCreate = () => {
    dispatch(
      postClientContract({
        name,
        type: selectedImages.length ? DOCUMENT_MEDIA_TYPE.photo : DOCUMENT_MEDIA_TYPE.pdf,
        files: selectedImages.length ? selectedImages : selectedFile,
        userId: id,
      }),
    )
      .unwrap()
      .then(() => {
        setName('');
        setSelectedFile([]);
        setSelectedImages([]);
        setSelectedImagesPrev([]);
        setIsModalOpen(false);
      })
      .catch(err => {
        notifyErrorLeft(err.message);
      });
  };

  const handleDocumentDetails = id => {
    setContractModalIsOpen(true);

    dispatch(getDocumentById(id))
      .unwrap()
      .then(result => {
        setNewTitle(result.data.name);
      })
      .catch(err => {
        console.log(err);
        notifyError(err.message);
      });
  };

  const handleDeleteDocument = id => {
    setSelectedContractToDeleteId(id);
    dispatch(deleteDocument({ id }))
      .unwrap()
      .then(() => {
        setSelectedContractToDeleteId(null);
      })
      .catch(err => {
        console.log(err);
        notifyError(err.message);
        setSelectedContractToDeleteId(null);
      });
  };

  const handleDownload = (urlArray, type, id) => {
    if (type === 'pdf') {
      setDownloadLoading(true);
      setPdfToDownloadId(id);
      if (!urlArray.length) {
        dispatch(getDocumentById(id))
          .unwrap()
          .then(data => {
            const pdfWindow = window.open();
            pdfWindow.location.href = data.data.documentMedia[0].url;
            setDownloadLoading(false);
            setPdfToDownloadId(null);
          })
          .catch(err => {
            console.log(err);
            notifyError(err.message);
            setDownloadLoading(false);
          });
      } else {
        const pdfWindow = window.open();
        pdfWindow.location.href = urlArray[0].url;
      }
    } else {
      for (const url of urlArray) {
        window.open(url.url, '_blank');
      }
    }
  };

  const handleRemoveImage = index => {
    setSelectedImagesPrev(prevSelectedImages => prevSelectedImages.filter((_, i) => i !== index));
    setSelectedImages(prev => prev.filter((_, i) => i !== index));
  };

  const handleEditContract = () => {
    dispatch(editDocument({ id: selectedContract.id, name: newTitle }))
      .then(() => {
        setEdit(!edit);
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  return (
    <ContentContainer>
      <TabContainer>
        <TabTitle>Contracts & Documents</TabTitle>
        <AddButton onClick={openModal}>
          <Add />
          <AddText>Upload</AddText>
        </AddButton>
      </TabContainer>
      {!fetchClientContractsPending ? (
        <>
          {contracts.data.length ? (
            <Content className="vertical-scroll">
              {contracts.data.map(item => (
                <ContractContainer key={item.id}>
                  <ContractInfoMediaContainer>
                    {item.media && item.media.length ? (
                      <>
                        {item.mediaType === 'pdf' ? (
                          <img
                            src={require('../../../assets/images/contractDefault.png')}
                            alt="photoImg"
                            className="contract-photo"
                            onClick={() => {
                              handleDocumentDetails(item.id);
                            }}
                          />
                        ) : (
                          <img
                            src={item.media[0].url}
                            alt="photoImg"
                            className="contract-photo"
                            onClick={() => {
                              handleDocumentDetails(item.id);
                            }}
                          />
                        )}
                      </>
                    ) : (
                      <img
                        src={require('../../../assets/images/contractDefault.png')}
                        alt="photoImg"
                        className="contract-photo"
                        onClick={() => {
                          handleDocumentDetails(item.id);
                        }}
                      />
                    )}
                    <ContractInfo>
                      <Date>{dateFormatter(item.createdAt)}</Date>
                      <ContractName>{item.name}</ContractName>
                      <UploadedBy>
                        <UploadedBy $opacity>Uploaded by: </UploadedBy>
                        {item.createdBy === DOCUMENT_CREATOR.USER ? firstName + ' ' + lastName : 'You'}
                      </UploadedBy>
                    </ContractInfo>
                  </ContractInfoMediaContainer>
                  <IconsContainer>
                    <IconContainer
                      onClick={() => {
                        handleDocumentDetails(item.id);
                      }}>
                      <Edit width={25} />
                    </IconContainer>
                    <IconContainer onClick={() => handleDownload(item.media, item.mediaType, item.id)}>
                      {downloadLoading && pdfToDownloadId === item.id ? (
                        <Waveform size={25} lineWeight={3} speed={1} color="black" />
                      ) : (
                        <Download width={25} height={25} />
                      )}
                    </IconContainer>

                    {item.createdBy === DOCUMENT_CREATOR.VENDOR && (
                      <IconContainer
                        onClick={() => {
                          setAreYouSureModal(true);
                          setDocumentId(item.id);
                        }}>
                        {deleteDocumentPending && selectedContractToDeleteId === item.id ? (
                          <Waveform size={22} lineWeight={3} speed={1} color="black" />
                        ) : (
                          <Delete width={22} />
                        )}
                      </IconContainer>
                    )}
                  </IconsContainer>
                </ContractContainer>
              ))}
            </Content>
          ) : (
            <LoaderContainerMargin>
              <ContractName>You don't have contracts with {firstName + ' ' + lastName}.</ContractName>
            </LoaderContainerMargin>
          )}
        </>
      ) : (
        <LoaderContainerMargin>
          <Waveform size={40} lineWeight={3.5} speed={1} color="black" />
        </LoaderContainerMargin>
      )}
      <ModalComponent
        isOpen={isModalOpen}
        onClose={closeModal}
        title={'Upload Document'}
        onCreate={handleCreate}
        createDisabled={!name || (!selectedFile.length && !selectedImages.length)}
        cancelDisabled={postClientContractPending}
        width={'800px'}
        loading={postClientContractPending}>
        {selectedImagesPrev.length === 0 && selectedFile.length === 0 ? (
          <Buttons className="margin-bottom">
            <UploadContainer>
              <>
                <PdfUpload onChange={handleFileInputChange} type="file" accept=".pdf" />
                <Upload />
                Upload File
              </>
            </UploadContainer>
            <UploadContainer>
              <>
                <ImgUpload multiple onChange={handlePhotoInputChange} type="file" accept=".jpg, .jpeg, .png" />
                <Upload />
                Upload Photo
              </>
            </UploadContainer>
          </Buttons>
        ) : (
          <>
            {selectedImagesPrev.length ? (
              <ImagesContainer className="vertical-scroll">
                {selectedImagesPrev.map((image, index) => (
                  <div key={index} style={{ position: 'relative' }}>
                    <RemoveIcon onClick={() => handleRemoveImage(index)}>
                      <Remove />
                    </RemoveIcon>

                    <ImagePreview src={image} alt={`Selected ${index + 1}`} />
                  </div>
                ))}
                <Buttons>
                  <AddPhotoContainer>
                    <InputImage multiple onChange={handlePhotoInputChange} type="file" accept=".jpg, .jpeg, .png" />
                    <Upload />
                    Add Another Page
                  </AddPhotoContainer>
                </Buttons>
              </ImagesContainer>
            ) : (
              <PdfContainer>
                <PdfViewer document={selectedFile[0]} width={500} />
              </PdfContainer>
            )}
          </>
        )}
        <StyledInput placeholder="Document Name" onChange={n => setName(n.target.value)} value={name} />
      </ModalComponent>

      <ModalComponent
        isOpen={contractModalIsOpen}
        onClose={closeModalDetails}
        title={selectedContract.name}
        width={'900px'}
        notShowButtons={true}
        newTitle={newTitle}
        setNewTitle={setNewTitle}
        setEdit={setEdit}
        edit={edit}
        contentLoading={getDocumentByIdPending}
        onEdit={handleEditContract}
        editLoading={editLoading}
        editable>
        <div style={{ maxHeight: 1100, overflow: 'auto' }}>
          {!getDocumentByIdPending ? (
            selectedContract.type === 'pdf' ? (
              <PdfContainerDetails>
                <PdfViewer document={selectedContract.documentMedia[0].url} width={800} />
              </PdfContainerDetails>
            ) : (
              <>
                {selectedContract && selectedContract.documentMedia && (
                  <ContractImagesContainer>
                    {selectedContract.documentMedia.map((image, index) => (
                      <ImagePreviewBig key={index} src={image.url} alt={`Selected ${index + 1}`} />
                    ))}
                  </ContractImagesContainer>
                )}
              </>
            )
          ) : (
            <LoadingContainer>
              <Waveform size={40} lineWeight={3.5} speed={1} color="black" />
            </LoadingContainer>
          )}
        </div>
      </ModalComponent>
      {isVisible && (
        <>
          <Background $open={areYouSureModal} $bg />
          <SmallModalContainer $open={areYouSureModal}>
            <ModalTitleSmall style={{ textAlign: 'center' }}>
              Are you sure you want to delete this contract?
            </ModalTitleSmall>
            <ButtonContainerGap style={{ gap: 20 }}>
              <StyledButton onClick={() => setAreYouSureModal(false)}>
                <ButtonText>Cancel</ButtonText>
              </StyledButton>

              <StyledButton
                onClick={() => {
                  if (!deleteDocumentPending) {
                    handleDeleteDocument(documentId);
                    setDocumentId('');
                    setAreYouSureModal(false);
                  }
                }}
                $disabled={deleteDocumentPending}
                $black>
                {!deleteDocumentPending ? (
                  <ButtonText $black>Yes</ButtonText>
                ) : (
                  <Waveform size={26} lineWeight={3.5} speed={1} color="white" />
                )}
              </StyledButton>
            </ButtonContainerGap>
          </SmallModalContainer>
        </>
      )}
    </ContentContainer>
  );
};

export default Contracts;
